<div class="card1 p-3" style="cursor: pointer;" (click)="onCardClick()">
  <div class="d-flex align-items-start">
    <img [src]="project.images && project.images[0] || 'https://upload.wikimedia.org/wikipedia/commons/6/65/No-Image-Placeholder.svg'"
         class="square-img me-3 rounded-2 flex-shrink-0"
         alt="Project Image">

    <div class="details flex-grow-1 overflow-hidden">
      <h4 class="custom-card-title text-truncate w-100">
        {{ project.title | titlecase }}@if (project.isDuplicate) {<span> (Duplicate)</span>}
      </h4>
      <h5 class="card-subtitle mb-2 text-truncate w-100">
        {{ project.school | titlecase }} ({{ project.teachingLevel | titlecase }})
      </h5>
    </div>
  </div>

  <div class="row row-cols-2">
  <div class="details mt-1 row row-cols-1">
    <!--<p class="card-text mb-1">Courses: {{ project.selectedCourses.join(', ') }}</p>-->

    @if (project.projectStatus) {
      <p class="card-text mb-1 col">
        <strong>Project Status:</strong> {{ project.projectStatus }}
      </p>
    }

    @if (project.schoolYear) {
      <p class="card-text mb-1 col">
        <strong>School Year:</strong> {{ project.schoolYear }}
      </p>
    }

    @if (project.startDate && project.endDate) {
      <p class="card-text mb-1 col">
        <strong>Dates:</strong>
        {{ project.startDate | date:'MM/dd/yyyy' }} –
        {{ project.endDate | date:'MM/dd/yyyy' }}
      </p>
    }
  </div>
  <div class="details mt-1 row row-cols-1">
    @if (getAssociatedAnnualProfileTeacher() != '') {
      <p class="card-text mb-1 col">
        <strong>Associated GHS Teacher Rep:</strong> {{ getAssociatedAnnualProfileTeacher() }}
      </p>
    }
  </div>
</div>
</div>
